<footer [ngClass]="{'w-100': fullWidth}">
    <div class="footerTxt">
        <h6>Long & Foster’s Integrated Network of Services</h6>
        <span class="middleBdr"></span>
    </div>
    <ul class="footerIcons">
        <li><a href="{{sharePointUrl}}intranet-realestate" target="_blank" rel="noopener"><img
                    src="{{assetsUrl}}RealEstate.png" alt="realEstate" title="" href="">
                <p>Real Estate</p>
            </a></li>
        <li><a href="{{sharePointUrl}}intranet-prosperityhomemortgage" target="_blank" rel="noopener"><img
                    src="{{assetsUrl}}Mortgage.png" alt="mortgage" title="" href="">
                <p>Mortgage</p>
            </a></li>
        <li><a href="{{sharePointUrl}}intranet-insurance" target="_blank" rel="noopener"><img
                    src="{{assetsUrl}}Insurance.png" alt="insurance" title="" href="">
                <p>Insurance</p>
            </a></li>
        <li><a href="{{sharePointUrl}}intranet-settlementservices" target="_blank" rel="noopener"><img
                    src="{{assetsUrl}}Title.png" alt="title" title="" href="">
                <p>Title</p>
            </a></li>
        <li><a href="https://insightinspections.com/schedule/"
                target="_blank" rel="noopener"><img src="{{assetsUrl}}Inspections.png" alt="inspections" title="" href="">
                <p>Inspections</p>
            </a></li>
        <li><a href="{{sharePointUrl}}intranet-insurance/SitePages/Home-Warranty-Plans.aspx"
                target="_blank" rel="noopener"><img src="{{assetsUrl}}HomeWarranty.png" alt="homeWarranty" title="" href="">
                <p>Home Warranty</p>
            </a></li>
        <li><a href="{{sharePointUrl}}intranet-tailoredmove" target="_blank" rel="noopener"><img
                    src="{{assetsUrl}}Moving.png" alt="moving" title="" href="">
                <p>Moving</p>
            </a></li>
        <li><a href="{{sharePointUrl}}intranet-propertymanagement" target="_blank" rel="noopener"><img
                    src="{{assetsUrl}}property.png" alt="property" title="" href="">
                <p>Property Management</p>
            </a></li>
        <li><a href="{{sharePointUrl}}intranet-vacationrentals" target="_blank" rel="noopener"><img
                    src="{{assetsUrl}}VacationRentals.png" alt="vacationRentals" title="" href="">
                <p>Vacation Rentals</p>
            </a></li>
        <li><a href="{{urbanPaceUrl}}" target="_blank" rel="noopener"><img
                    src="{{assetsUrl}}DevelopersServices.png" alt="developersServices" title="" href="">
                <p>Developer Services</p>
            </a></li>
    </ul>
</footer>
<!-- Form Mobile -->
<footer class="resFooter" [ngClass] ="{'smartpadding' : isSuperAdmin || isOfficeManagerUser}">
    <div class="footerTxt">
        <h6>Long & Foster’s Integrated Network of Services</h6>
        <span class="middleBdr"></span>
    </div>
    <ul class="footerIcons mt16">
        <li><a href="{{sharePointUrl}}intranet-realestate" target="_blank" rel="noopener"><img
                    src="{{assetsUrl}}RealEstate.png" alt="realEstateMob" title="" href="">
                <p>Real Estate</p>
            </a></li>
        <li><a href="{{sharePointUrl}}intranet-prosperityhomemortgage" target="_blank" rel="noopener"><img
                    src="{{assetsUrl}}Mortgage.png" alt="mortgageMob" title="" href="">
                <p>Mortgage</p>
            </a></li>
        <li><a href="{{sharePointUrl}}intranet-insurance" target="_blank" rel="noopener"><img
                    src="{{assetsUrl}}Insurance.png" alt="insuranceMob" title="" href="">
                <p>Insurance</p>
            </a></li>
        <li><a href="{{sharePointUrl}}intranet-settlementservices" target="_blank" rel="noopener"><img
                    src="{{assetsUrl}}Title.png" alt="titleMob" title="" href="">
                <p>Title</p>
            </a></li>
        <li><a href="https://insightinspections.com/schedule/"
                target="_blank" rel="noopener"><img src="{{assetsUrl}}Insurance.png" alt="intraInsuranceMob" title="" href="">
                <p>Inspections</p>
            </a></li>
    </ul>
    <ul class="footerIcons">
        <li><a href="{{sharePointUrl}}intranet-insurance/SitePages/Home-Warranty-Plans.aspx"
                target="_blank" rel="noopener"><img src="{{assetsUrl}}HomeWarranty.png" alt="homeWarrantyMob" title="" href="">
                <p>Home Warranty</p>
            </a></li>
        <li><a href="{{sharePointUrl}}intranet-tailoredmove" target="_blank" rel="noopener"><img
                    src="{{assetsUrl}}Moving.png" alt="movingMob" title="" href="">
                <p>Moving</p>
            </a></li>
        <li><a href="{{sharePointUrl}}intranet-propertymanagement" target="_blank" rel="noopener"><img
                    src="{{assetsUrl}}property.png" alt="propertyMob" title="" href="">
                <p>Property Management</p>
            </a></li>
        <li><a href="{{sharePointUrl}}intranet-vacationrentals" target="_blank" rel="noopener"><img
                    src="{{assetsUrl}}VacationRentals.png" alt="vacationRentalsMob" title="" href="">
                <p>Vacation Rentals</p>
            </a></li>
        <li><a href="{{urbanPaceUrl}}" target="_blank" rel="noopener"><img
                    src="{{assetsUrl}}DevelopersServices.png" alt="developersServicesMob" title="" href="">
                <p>Developer Services</p>
            </a></li>
    </ul>
</footer>